import { NzTransferModule } from 'ng-zorro-antd/transfer';

import { NgModule } from '@angular/core';
// d3 related
import { GraphComponent } from '@shared/components/d3-visuals/graph/graph.component';
import { SHARED_VISUALS } from '@shared/components/d3-visuals/shared';
// generic
import { BaseSkeletonComponent } from '@shared/components/dynamic-components/base-skeleton/base-skeleton.component';
import { DurationsComponent } from '@shared/components/dynamic-components/durations/durations.component';
import { IconComponent } from '@shared/components/dynamic-components/icon/icon.component';
import { AddAddonModalComponent } from '@shared/components/modals/add-addon-modal/add-addon-modal.component';
import { InitializeAgileSpaceModalComponent } from '@shared/components/modals/initialize-agile-space-modal/initialize-agile-space-modal.component';
// modals
import { AddAnalysisModalComponent } from '@shared/components/modals/add-analysis-modal/add-analysis-modal.component';
import { AddDatasourceModalComponent } from '@shared/components/modals/add-datasource-modal/add-datasource-modal.component';
import { AddDeploymentAnalyticsComponent } from '@shared/components/modals/add-deployment-analytics/add-deployment-analytics.component';
import { AddDeveloperModalComponent } from '@shared/components/modals/add-developer-modal/add-developer-modal.component';
import { AddGroupModalComponent } from '@shared/components/modals/add-group-modal/add-group-modal.component';
import { AddKpiModalComponent } from '@shared/components/modals/add-kpi-modal/add-kpi-modal.component';
import { AddLeagueModalComponent } from '@shared/components/modals/add-league-modal/add-league-modal.component';
import { AddPortfolioItemModalComponent } from '@shared/components/modals/add-portfolio-item-modal/add-portfolio-item-modal.component';
import { AddPortfolioModalComponent } from '@shared/components/modals/add-portfolio-modal/add-portfolio-modal.component';
import { AddTeamModalComponent } from '@shared/components/modals/add-team-modal/add-team-modal.component';
import { AddUserFromCSVModalComponent } from '@shared/components/modals/add-user-from-CSV-modal/add-user-from-CSV-modal.component';
import { ManageMemberModalComponent } from "@shared/components/modals/manage-member-modal/manage-member-modal.component";
import { AddUserFromLDAPComponent } from "@shared/components/modals/add-user-from-LDAP/add-user-from-LDAP.component";
import { AddWidgetModalComponent } from '@shared/components/modals/add-widget-modal/add-widget-modal.component';
import { AgileSpaceNotificationModalComponent } from '@shared/components/modals/agile-space-notification-modal/agile-space-notification-modal.component';
import { DashboardSettingsModalComponent } from '@shared/components/modals/dashboard-settings-modal/dashboard-settings-modal.component';
import { DashboardTypeSelectionModalComponent } from '@shared/components/modals/dashboard-type-selection-modal/dashboard-type-selection-modal.component';
import { DatasourceListModalComponent } from '@shared/components/modals/datasource-list-modal/datasource-list-modal.component';
import { DeleteConfirmModalComponent } from '@shared/components/modals/delete-confirm-modal/delete-confirm-modal.component';
import { DeveloperListModalComponent } from '@shared/components/modals/developer-list-modal/developer-list-modal.component';
import { EmptyWidgetModalComponent } from '@shared/components/modals/empty-widget-modal/empty-widget-modal.component';
import { ExcludeCommitModalComponent } from '@shared/components/modals/exclude-commit-modal/exclude-commit-modal.component';
import { GitwiserNotificationModalComponent } from '@shared/components/modals/gitwiser-notification-modal/gitwiser-notification-modal.component';
import { ImportUserLdapComponent } from '@shared/components/modals/import-user-ldap/import-user-ldap.component';
import { InitializeScorecardModalComponent } from '@shared/components/modals/initialize-scorecard-modal/initialize-scorecard-modal.component';
import { KpiListModalComponent } from '@shared/components/modals/kpi-list-modal/kpi-list-modal.component';
import { NotificationModalComponent } from '@shared/components/modals/notification-modal/notification-modal.component';
import { PluginInformationModalComponent } from '@shared/components/modals/plugin-information-modal/plugin-information-modal.component';
import { ScheduledReportsSettingsComponent } from '@shared/components/modals/scheduled-reports-settings/scheduled-reports-settings.component';
import { SelectionAgileSpaceModalComponent } from '@shared/components/modals/selection-agile-space-modal/selection-agile-space-modal.component';
import { SelectionModalComponent } from '@shared/components/modals/selection-modal/selection-modal.component';
import { StatusDeploymentDuringModalComponent } from '@shared/components/modals/status-deployment-during-modal/status-deployment-during-modal.component';
import { UpdateAnalysisModalComponent } from '@shared/components/modals/update-analysis-modal/update-analysis-modal.component';
import { UpdateDeploymentAnalyticsComponent } from '@shared/components/modals/update-deployment-analytics/update-deployment-analytics.component';
import { WelcomeModalComponent } from '@shared/components/modals/welcome-modal/welcome-modal.component';
// widgets
import { WidgetDatePickerDropdownComponent } from '@shared/components/modals/widget-date-picker-dropdown/widget-date-picker-dropdown.component';
import { AzureDevopsBoardsComponent } from '@shared/components/widgets/azure-devops-boards/azure-devops-boards.component';
import { AzureDevopsReleaseWidgetComponent } from '@shared/components/widgets/azure-devops-release-widget/azure-devops-release-widget.component';
import { AzureDevopsSprintsWidgetComponent } from '@shared/components/widgets/azure-devops-sprints-widget/azure-devops-sprints-widget.component';
import { BaseWidgetComponent } from '@shared/components/widgets/base-widget/base-widget.component';
import { ClosedMergeRequestWidgetComponent } from '@shared/components/widgets/closed-merge-request-widget/closed-merge-request-widget.component';
import { CustomAddonTableWidgetComponent } from '@shared/components/widgets/custom-addon-table-widget/custom-addon-table-widget.component';
import { DeploymentAnalyticsWidgetComponent } from '@shared/components/widgets/deployment-analytics-widget/deployment-analytics-widget.component';
import { JenkinsWidgetComponent } from '@shared/components/widgets/jenkins-widget/jenkins-widget.component';
import { JiraIssuesWidgetComponent } from '@shared/components/widgets/jira-issues-widget/jira-issues-widget.component';
import { PerformanceMetricsWidgetComponent } from '@shared/components/widgets/performance-metrics-widget/performance-metrics-widget.component';
import { PictorialWidgetComponent } from '@shared/components/widgets/pictorial-widget/pictorial-widget.component';
import { RepoStatsWidgetComponent } from '@shared/components/widgets/repo-stats-widget/repo-stats-widget.component';
import { RepositoryStatsWidgetComponent } from '@shared/components/widgets/repository-stats-widget/repository-stats-widget.component';
import { StatusBoardWidgetComponent } from '@shared/components/widgets/status-board-widget/status-board-widget.component';
import { StatusProgressWidgetComponent } from '@shared/components/widgets/status-progress-widget/status-progress-widget.component';
import { TextPanelWidgetComponent } from '@shared/components/widgets/text-panel-widget/text-panel-widget.component';
import { TransactionWidgetComponent } from '@shared/components/widgets/transaction-widget/transaction-widget.component';
import { WidgetEditComponent } from '@shared/components/widgets/widget-components/widget-edit/widget-edit.component';
import { WidgetFooterComponent } from '@shared/components/widgets/widget-components/widget-footer/widget-footer.component';
import { WidgetHeaderComponent } from '@shared/components/widgets/widget-components/widget-header/widget-header.component';
import { WidgetStatePlaceholderComponent } from '@shared/components/widgets/widget-components/widget-state-placeholder/widget-state-placeholder.component';
import { WorkItemsTableWidgetComponent } from '@shared/components/widgets/work-items-table-widget/work-items-table-widget.component';
import { DraggableDirective } from '@shared/directives/draggable.directive';
import { ZoomableDirective } from '@shared/directives/zoomable.directive';
import { SharedModule } from '@shared/shared.module';

import { DaterangepickerComponent } from './daterangepicker/daterangepicker.component';
import { LicenseAlertComponent } from './license-alert/license-alert.component';
import { PlaygroundAlertComponent } from './playground-alert/playground-alert.component';
import { DatedifferencePipe } from './daterangepicker/datedifference/datedifference.pipe';
import { AnalysisActivityComponent } from '@shared/components/drawer/gitwiser/activity/analysis-activity.component';
import { AnalysisActivityLogComponent } from '@shared/components/drawer/gitwiser/activity/log/analysis-activity-log.component';
import { ExportDataModalComponent } from '../modals/export-data-modal/export-data-modal.component';
import { TableExportToExcelComponent } from '@shared/components/tables/table-export-to-excel.component';
import { ExportDeveloperDataModalComponent } from '../modals/export-developer-data-modal/export-developer-data-modal.component';
import { InitializeAnalysisV2ModalComponent } from '../modals/add-analysis-v2/initialize-analysis-v2-modal.component';
import { FortifyWidgetComponent } from "@shared/components/widgets/fortify-widget/fortify-widget.component";
import {
  SelectionQwiserModalComponent
} from "@shared/components/modals/selection-qwiser-modal/selection-qwiser-modal.component";
import {
  InitializeQwiserModalComponent
} from "@shared/components/modals/initialize-qwiser-modal/initialize-qwiser-modal.component";

import { ExcludePRModalComponent } from '@shared/components/modals/exclude-pr-modal/exclude-pr-modal.component';

// third party modules

const COMPONENTS = [
  DurationsComponent,
  IconComponent,
  BaseSkeletonComponent,
  PlaygroundAlertComponent,
  LicenseAlertComponent,
  GraphComponent,
  ...SHARED_VISUALS,
  WidgetEditComponent,
  WidgetFooterComponent,
  WidgetHeaderComponent,
  WidgetDatePickerDropdownComponent,
  WidgetStatePlaceholderComponent,
  WelcomeModalComponent,
  DaterangepickerComponent,

];

const DIRECTIVES = [
  DraggableDirective,
  ZoomableDirective
];

// not to loose references at compile time
const ENTRY_COMPONENTS = [
  AddAnalysisModalComponent,
  AddAddonModalComponent,
  AddDatasourceModalComponent,
  AddDeveloperModalComponent,
  AddGroupModalComponent,
  AddKpiModalComponent,
  AddLeagueModalComponent,
  AddPortfolioItemModalComponent,
  AddTeamModalComponent,
  AddUserFromCSVModalComponent,
  AddUserFromLDAPComponent,
  AddPortfolioModalComponent,
  AddWidgetModalComponent,
  BaseWidgetComponent,
  DashboardSettingsModalComponent,
  DashboardTypeSelectionModalComponent,
  DatasourceListModalComponent,
  DeleteConfirmModalComponent,
  DeveloperListModalComponent,
  SelectionModalComponent,
  GitwiserNotificationModalComponent,
  ImportUserLdapComponent,
  InitializeScorecardModalComponent,
  JenkinsWidgetComponent,
  JiraIssuesWidgetComponent,
  KpiListModalComponent,
  PerformanceMetricsWidgetComponent,
  TextPanelWidgetComponent,
  PictorialWidgetComponent,
  PluginInformationModalComponent,
  RepoStatsWidgetComponent,
  StatusBoardWidgetComponent,
  StatusProgressWidgetComponent,
  RepositoryStatsWidgetComponent,
  ClosedMergeRequestWidgetComponent,
  ScheduledReportsSettingsComponent,
  WelcomeModalComponent,
  AzureDevopsBoardsComponent,
  AzureDevopsSprintsWidgetComponent,
  NotificationModalComponent,
  TransactionWidgetComponent,
  CustomAddonTableWidgetComponent,
  UpdateAnalysisModalComponent,
  InitializeAgileSpaceModalComponent,
  AgileSpaceNotificationModalComponent,
  SelectionAgileSpaceModalComponent,
  AzureDevopsReleaseWidgetComponent,
  WorkItemsTableWidgetComponent,
  ExcludeCommitModalComponent,
  AddDeploymentAnalyticsComponent,
  UpdateDeploymentAnalyticsComponent,
  DeploymentAnalyticsWidgetComponent,
  StatusDeploymentDuringModalComponent,
  EmptyWidgetModalComponent,
  ManageMemberModalComponent,
  AnalysisActivityComponent,
  AnalysisActivityLogComponent,
  ExportDataModalComponent,
  ExportDeveloperDataModalComponent,
  InitializeAnalysisV2ModalComponent,
  FortifyWidgetComponent,
  ExportDeveloperDataModalComponent,
  SelectionQwiserModalComponent,
  InitializeQwiserModalComponent,
  ExcludePRModalComponent,
  TableExportToExcelComponent
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...ENTRY_COMPONENTS,
    DatedifferencePipe,
  ],
  imports: [
    SharedModule,
    NzTransferModule
  ],
  exports: [
    ...COMPONENTS,
    ...DIRECTIVES
  ]
})
export class DynamicComponentsModule {}
